<template>
    <div>
        <b-nav tabs>
            <b-nav-item router-link to="overview" v-if="canInventoryOverviewView || accessUser.includes(this.user.username)">
                <icon name="file-alt"></icon> รายงานการจองสินค้า
            </b-nav-item>
            <b-nav-item router-link to="overview_sale" v-if="canInventoryOverviewView">
                <icon name="file-alt"></icon> รายงานการจองแยกรายเซลล์
            </b-nav-item>
        </b-nav>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>

import {mapState} from "vuex";
import {canInventoryOverviewView} from "@/util/Permissions";

export default {
    name: "overview",
    data() {
        return {
            accessUser:[
                "10389",
                "20502",
                "20534",
                "20566",
                "10071",
                "10070",
                "10388",
                "10389",
                "10618",
                "20505",
                "20507",
                "10803",
                "10502",
            ]
        };
    },
    computed: {
        canInventoryOverviewView,
        ...mapState({
            user: state => {
                return state.Auth.user;
            }
        })
    },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/tab-bar.css";
</style>
